<template>
  <div>
    <el-select
      style="width: 100%;"
      size="mini"
      v-model="mwActiveId"
      placeholder="请选择墓位"
      @change="mwActivecChange"
    >
      <el-option
        v-for="item in mwList"
        :key="item.id"
        :label="item.graveName + item.sizhe"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { getStore, removeStore, setStore, clearStore } from '@/utils/store';

export default {
  components: {},
  data() {
    return {
      mwActiveId: '',
      mwList: [],
    };
  },
  methods: {
    // type=true 默认选第0位 用于解绑\绑定
    getUserGraveListFn(type = true) {
      this.$store
        .dispatch('GetUserGraveList', { pageNum: 1, pageSize: 10000 })
        .then((res) => {
          this.mwList = res.rows;
          if (type) {
            if (this.mwList[0]) {
              this.mwActiveId = this.mwList[0].id;
            } else {
              this.mwActiveId = '';
            }
          }else{
            this.mwActiveId = getStore({ name: 'mwActive' }).id;
          }
        });
      // getUserGraveList(1, 10000).then((res) => {
      //   this.mwList = res.rows;
      //   if (this.mwList[0]) {
      //     this.mwActiveId = this.mwList[0].id;
      //   } else {
      //     this.mwActiveId = '';
      //   }
      // });
    },
    mwActivecChange(val) {
      console.log(val);
    },
  },
  created() {},
  props: {},
  watch: {
    mwActiveId(val) {
      const obj = this.mwList.find((i) => +i.id === +val);
      setStore({
        name: 'mwActive',
        content: obj,
        type: 'sessionStorage',
      });
      this.$emit('muWeiChange', obj || {});
    },
  },
  computed: {},
  mounted() {
    if (getStore({ name: 'mwActive' })) {
      
      this.getUserGraveListFn(false);
    } else {
      this.getUserGraveListFn();
    }
  },
};
</script>

<style scoped lang="scss"></style>
